import { printHelp } from "../../util";

export default function (p) {
  console.dir("2232323");
  console.dir(p);
}
